import { getCustomQueries } from '@/helpers/queryHelper';
import {
  GET_PHYSICAL_CLASS_INFO_FAILED,
  GET_PHYSICAL_CLASS_INFO_REQUEST,
  GET_PHYSICAL_CLASS_INFO_SUCCEEDED,
  GET_PHYSICAL_CLASS_REQUEST,
  GET_PHYSICAL_CLASS_FAILED,
  GET_PHYSICAL_CLASS_SUCCEEDED,
  ADD_PHYSICAL_CLASS_REQUEST,
  ADD_PHYSICAL_CLASS_SUCCEEDED,
  ADD_PHYSICAL_CLASS_FAILED,
  EDIT_PHYSICAL_CLASS_REQUEST,
  EDIT_PHYSICAL_CLASS_SUCCEEDED,
  EDIT_PHYSICAL_CLASS_FAILED,
  DELETE_PHYSICAL_CLASS_REQUEST,
  DELETE_PHYSICAL_CLASS_SUCCEEDED,
  DELETE_PHYSICAL_CLASS_FAILED,
  GET_PHYSICAL_CLASS_STUDENT_REQUEST,
  GET_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
  GET_PHYSICAL_CLASS_STUDENT_FAILED,
  ADD_PHYSICAL_CLASS_STUDENT_REQUEST,
  ADD_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
  ADD_PHYSICAL_CLASS_STUDENT_FAILED,
  EDIT_PHYSICAL_CLASS_STUDENT_REQUEST,
  DELETE_PHYSICAL_CLASS_STUDENT_REQUEST,
  DELETE_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
  DELETE_PHYSICAL_CLASS_STUDENT_FAILED,
  SET_PHYSICAL_CLASS_DATA,
  SET_PHYSICAL_CLASS_ERROR_DATA,
  EDIT_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
  EDIT_PHYSICAL_CLASS_STUDENT_FAILED,
  GET_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
  GET_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
  GET_PHYSICAL_CLASS_ATTENDANCE_FAILED,
  ADD_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
  ADD_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
  ADD_PHYSICAL_CLASS_ATTENDANCE_FAILED,
  EDIT_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
  EDIT_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
  EDIT_PHYSICAL_CLASS_ATTENDANCE_FAILED,
  GET_PHYSICAL_CLASS_LIST_REQUEST,
  GET_PHYSICAL_CLASS_LIST_SUCCEEDED,
  GET_PHYSICAL_CLASS_LIST_FAILED,
  GET_PHYSICAL_CLASS_LIST_DETAIL_REQUEST,
  GET_PHYSICAL_CLASS_LIST_DETAIL_SUCCEEDED,
  GET_PHYSICAL_CLASS_LIST_DETAIL_FAILED,
  POST_PHYSICAL_CLASS_BOOK_REQUEST,
  POST_PHYSICAL_CLASS_BOOK_SUCCEEDED,
  POST_PHYSICAL_CLASS_BOOK_FAILED,
  GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_REQUEST,
  GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_SUCCEEDED,
  GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_FAILED,
  UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_REQUEST,
  UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_SUCCEEDED,
  UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_FAILED,
  GET_PHYSICAL_CLASS_BATCHES_REQUEST,
  GET_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
  GET_PHYSICAL_CLASS_BATCHES_FAILED,
  Add_PHYSICAL_CLASS_BATCHES_REQUEST,
  Add_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
  Add_PHYSICAL_CLASS_BATCHES_FAILED,
  Edit_PHYSICAL_CLASS_BATCHES_REQUEST,
  Edit_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
  Edit_PHYSICAL_CLASS_BATCHES_FAILED,
  Delete_PHYSICAL_CLASS_BATCHES_REQUEST,
  Delete_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
  Delete_PHYSICAL_CLASS_BATCHES_FAILED,
  GET_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
  GET_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
  GET_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
  ADD_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
  ADD_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
  ADD_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
  EDIT_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
  EDIT_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
  EDIT_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
  DELETE_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
  DELETE_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
  DELETE_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
  GET_PHYSICAL_CLASS_STUDENT_LIST_REQUEST,
  GET_PHYSICAL_CLASS_STUDENT_LIST_SUCCEEDED,
  GET_PHYSICAL_CLASS_STUDENT_LIST_FAILED,
} from '.';

//PHYSICAL CLASS
export const getPhysicalClasses = (data) => {
  let query = getCustomQueries(data?.data);

  return {
    type: GET_PHYSICAL_CLASS_REQUEST,
    payload: {
      url: `physical/class/?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_FAILED,
    },
  };
};

export const getPhysicalClassBySlug = (slug = {}) => {
  return {
    type: GET_PHYSICAL_CLASS_INFO_REQUEST,
    payload: {
      url: `physical/class/${slug}`,
      onSuccess: GET_PHYSICAL_CLASS_INFO_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_INFO_FAILED,
    },
  };
};

export const addPhysicalClass = (data = {}) => {
  return {
    type: ADD_PHYSICAL_CLASS_REQUEST,
    payload: {
      data,
      url: 'physical/class/',
      onSuccess: ADD_PHYSICAL_CLASS_SUCCEEDED,
      onFailure: ADD_PHYSICAL_CLASS_FAILED,
    },
  };
};

export const editPhysicalClass = (data = {}, slug = {}) => {
  return {
    type: EDIT_PHYSICAL_CLASS_REQUEST,
    payload: {
      data,
      url: `physical/class/${slug}/`,
      onSuccess: EDIT_PHYSICAL_CLASS_SUCCEEDED,
      onFailure: EDIT_PHYSICAL_CLASS_FAILED,
    },
  };
};

export const deletePhysicalClass = (id = {}) => {
  return {
    type: DELETE_PHYSICAL_CLASS_REQUEST,
    payload: {
      url: `physical/class/${id}`,
      onSuccess: DELETE_PHYSICAL_CLASS_SUCCEEDED,
      onFailure: DELETE_PHYSICAL_CLASS_FAILED,
    },
  };
};

//PHYSICAL CLASS STUDENT

export const getPhysicalClassStudents = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_PHYSICAL_CLASS_STUDENT_REQUEST,
    payload: {
      url: `physical/students/?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_STUDENT_FAILED,
    },
  };
};

export const addPhysicalClassStudent = (data = {}) => {
  return {
    type: ADD_PHYSICAL_CLASS_STUDENT_REQUEST,
    payload: {
      data,
      url: 'physical/students/',
      onSuccess: ADD_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
      onFailure: ADD_PHYSICAL_CLASS_STUDENT_FAILED,
    },
  };
};

export const editPhysicalClassStudent = (data = {}, slug = {}) => {
  return {
    type: EDIT_PHYSICAL_CLASS_STUDENT_REQUEST,
    payload: {
      data,
      url: `physical/students/${slug}/`,
      onSuccess: EDIT_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
      onFailure: EDIT_PHYSICAL_CLASS_STUDENT_FAILED,
    },
  };
};

export const deletePhysicalClassStudent = (id = {}) => {
  return {
    type: DELETE_PHYSICAL_CLASS_STUDENT_REQUEST,
    payload: {
      url: `physical/students/${id}`,
      onSuccess: DELETE_PHYSICAL_CLASS_STUDENT_SUCCEEDED,
      onFailure: DELETE_PHYSICAL_CLASS_STUDENT_FAILED,
    },
  };
};

//PHYSICAL CLASS ATTENDANCE
export const getPhysicalClassAttendance = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
    payload: {
      url: `physical/attendance/?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_ATTENDANCE_FAILED,
    },
  };
};

//GET STUDENT LIST ACCORDING TO DATE
export const getPhysicalClassStudentList = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_PHYSICAL_CLASS_STUDENT_LIST_REQUEST,
    payload: {
      url: `student-attendance-list/?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_STUDENT_LIST_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_STUDENT_LIST_FAILED,
    },
  };
};

export const addPhysicalClassAttendance = (data = {}) => {
  return {
    type: ADD_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
    payload: {
      data,
      url: 'physical/attendance/',
      onSuccess: ADD_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
      onFailure: ADD_PHYSICAL_CLASS_ATTENDANCE_FAILED,
    },
  };
};

export const editPhysicalClassAttendance = (data = {}, id = {}) => {
  return {
    type: EDIT_PHYSICAL_CLASS_ATTENDANCE_REQUEST,
    payload: {
      data,
      url: `physical/attendance/${id}/`,
      onSuccess: EDIT_PHYSICAL_CLASS_ATTENDANCE_SUCCEEDED,
      onFailure: EDIT_PHYSICAL_CLASS_ATTENDANCE_FAILED,
    },
  };
};

//PHYSICAL CLASS ATTENDANCE END

export const setPhysicalClassData = (data = {}) => {
  return {
    type: SET_PHYSICAL_CLASS_DATA,
    payload: {
      data,
    },
  };
};

export const setPhysicalClassError = (data = {}) => {
  return {
    type: SET_PHYSICAL_CLASS_ERROR_DATA,
    payload: {
      data,
    },
  };
};

//Physical class list (landing)
export const getPhysicalClassLists = () => {
  return {
    type: GET_PHYSICAL_CLASS_LIST_REQUEST,
    payload: {
      url: 'physical-class-list',
      onSuccess: GET_PHYSICAL_CLASS_LIST_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_LIST_FAILED,
    },
  };
};

export const getPhysicalClassDetails = (id: number, selected_date: string) => {
  return {
    type: GET_PHYSICAL_CLASS_LIST_DETAIL_REQUEST,
    payload: {
      url: `physical-class-dates/?class_id=${id}&selected_date=${selected_date}`,
      onSuccess: GET_PHYSICAL_CLASS_LIST_DETAIL_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_LIST_DETAIL_FAILED,
    },
  };
};

export const bookPhysicalClass = (data = {}) => {
  return {
    type: POST_PHYSICAL_CLASS_BOOK_REQUEST,
    payload: {
      url: 'book-physical-class/',
      data,
      onSuccess: POST_PHYSICAL_CLASS_BOOK_SUCCEEDED,
      onFailure: POST_PHYSICAL_CLASS_BOOK_FAILED,
    },
  };
};

//physical class student request list
export const getphysicalClassBookRequests = (data = {}) => {
  let query = getCustomQueries(data);
  return {
    type: GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_REQUEST,
    payload: {
      url: `physical/class-booking/?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_BOOK_STUDENT_LIST_FAILED,
    },
  };
};
export const updatephysicalClassBookRequests = (data: object, id: number) => {
  return {
    type: UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_REQUEST,
    payload: {
      url: `physical/class-booking/${id}/`,
      data,
      onSuccess: UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_SUCCEEDED,
      onFailure: UPDATE_PHYSICAL_CLASS_BOOK_STUDENT_LIST_FAILED,
    },
  };
};
export const getPhysicalClassBatches = (data: object) => {
  let query = getCustomQueries(data);
  return {
    type: GET_PHYSICAL_CLASS_BATCHES_REQUEST,
    payload: {
      url: `physical/class-batch?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_BATCHES_FAILED,
    },
  };
};
export const addPhysicalClassBatches = (data: object) => {
  return {
    type: Add_PHYSICAL_CLASS_BATCHES_REQUEST,
    payload: {
      url: `physical/class-batch/`,
      data,
      onSuccess: Add_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
      onFailure: Add_PHYSICAL_CLASS_BATCHES_FAILED,
    },
  };
};
export const editPhysicalClassBatches = (data: object, id) => {
  return {
    type: Edit_PHYSICAL_CLASS_BATCHES_REQUEST,
    payload: {
      url: `physical/class-batch/${id}/`,
      data,
      onSuccess: Edit_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
      onFailure: Edit_PHYSICAL_CLASS_BATCHES_FAILED,
    },
  };
};
export const deletePhysicalClassBatches = (id) => {
  return {
    type: Delete_PHYSICAL_CLASS_BATCHES_REQUEST,
    payload: {
      url: `physical/class-batch/${id}/`,
      onSuccess: Delete_PHYSICAL_CLASS_BATCHES_SUCCEEDED,
      onFailure: Delete_PHYSICAL_CLASS_BATCHES_FAILED,
    },
  };
};

export const getPhysicalClassStudentTask = (data) => {
  let query = getCustomQueries(data);

  return {
    type: GET_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
    payload: {
      url: `client-tasks?${query}`,
      onSuccess: GET_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
      onFailure: GET_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
    },
  };
};
export const addPhysicalClassStudentTask = (data: object) => {
  return {
    type: ADD_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
    payload: {
      url: `add-booking-request-task/`,
      data,
      onSuccess: ADD_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
      onFailure: ADD_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
    },
  };
};
export const editPhysicalClassStudentTask = (data: object, id: number) => {
  return {
    type: EDIT_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
    payload: {
      url: `client-tasks/${id}/`,
      data,
      onSuccess: EDIT_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
      onFailure: EDIT_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
    },
  };
};
export const deletePhysicalClassStudentTask = (id: number) => {
  return {
    type: DELETE_PHYSICAL_CLASS_STUDENT_TASK_REQUEST,
    payload: {
      url: `client-tasks/${id}/`,
      onSuccess: DELETE_PHYSICAL_CLASS_STUDENT_TASK_SUCCEEDED,
      onFailure: DELETE_PHYSICAL_CLASS_STUDENT_TASK_FAILED,
    },
  };
};
